/*
  Месяцы, которых нет в отчёте 1С, а в портфеле по ним числится долг.

  Решение владельца 05.10.2026: 1С не показывает погашенных месяцев, поэтому
  такой долг считается погашенным - строка остаётся в истории счёта, а долга по
  ней больше нет. Человек видит перечень ДО записи («погасятся») и в итоге
  загрузки («погашены»): молча закрытый долг выглядел бы как пропажа денег.

  Длинный перечень свёрнут под кнопку: первая загрузка отчёта с сальдо поверх
  старых начислений может закрыть сотни месяцев разом, и таблица утопила бы
  остальную сводку.
*/

import { chargeMonth, money } from '../api/format.js'
import DeferredSettlement from './DeferredSettlement.jsx'
import Disclosure from './Disclosure.jsx'
import PageBar from './PageBar.jsx'
import usePaging from './usePaging.js'

const OPEN_LIMIT = 10

function Table({ months }) {
  // 21.10.2026: «сотни месяцев разом» - общая панель страниц под таблицей.
  const { rows, bar } = usePaging(months)
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>Лицевой счёт</th>
            <th>Месяц</th>
            <th>Услуга</th>
            <th className="table__num">Был долг</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((month) => (
            <tr key={`${month.account_number}|${month.period}|${month.service}`}>
              <td>{month.account_number}</td>
              <td data-label="Месяц">{chargeMonth(month.period)}</td>
              <td data-label="Услуга">{month.service}</td>
              <td className="table__num" data-label="Был долг">
                {money(month.debt_was)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <PageBar {...bar} what="месяцев" />
    </>
  )
}

/*
  `deferred` - погашение отложено сторожем объёма (19.10.2026): выгрузка в разы
  меньше прошлой, и месяцы ждут решения человека. Перечень тот же - что
  погасилось бы, - а под ним само решение.
*/
function wording(done, deferred) {
  if (deferred) {
    return [
      'Не погашены, ждут вашего решения',
      'Этих месяцев нет в отчёте 1С. Обычно это значит «погашено», но выгрузка в разы меньше прошлой, поэтому долг по ним пока остаётся.',
    ]
  }
  if (done) {
    return [
      'Погашены',
      'Этих месяцев нет в отчёте 1С, поэтому долг по ним считается погашенным. Строки остались в истории счёта.',
    ]
  }
  return [
    'Погасятся',
    'Этих месяцев нет в отчёте 1С, а в портфеле по ним числится долг. После загрузки он будет считаться погашенным: 1С не показывает погашенных месяцев.',
  ]
}

export default function OneCSettled({ months, done, deferral }) {
  if (!months?.length) return null
  const [head, why] = wording(done, Boolean(deferral))
  const title = `${head}: ${months.length}`
  return (
    <div className="onec__settled">
      {deferral ? (
        <DeferredSettlement runId={deferral.runId} doubt={deferral.doubt} count={months.length} />
      ) : null}
      {months.length > OPEN_LIMIT ? (
        <Disclosure title={title}>
          <p>{why}</p>
          <Table months={months} />
        </Disclosure>
      ) : (
        <>
          <p>
            <b>{title}</b>. {why}
          </p>
          <Table months={months} />
        </>
      )}
    </div>
  )
}
